export default '/build/e5eb52f0.svg'